/**
 * @generated SignedSource<<e08f272172841816b12ce5391bbbbf39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductInternalTools_user$data = {
  readonly canShowStorefrontOnlyBadge: boolean | null;
  readonly hasMerchandizingPermission?: boolean | null;
  readonly " $fragmentType": "ProductInternalTools_user";
};
export type ProductInternalTools_user$key = {
  readonly " $data"?: ProductInternalTools_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductInternalTools_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showMerchandizingTool"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductInternalTools_user",
  "selections": [
    {
      "condition": "showMerchandizingTool",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "hasMerchandizingPermission",
          "args": [
            {
              "kind": "Literal",
              "name": "name",
              "value": "BUYER_FE_MERCH_TOOL"
            }
          ],
          "kind": "ScalarField",
          "name": "hasPermission",
          "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
        }
      ]
    },
    {
      "alias": "canShowStorefrontOnlyBadge",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "VIEW_STOREFRONT_ONLY_BADGE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6263748bd94659b84a8dc5f04c13d3f4";

export default node;
